import { createRouter, createWebHistory } from 'vue-router'
import AnagraficaView from '../views/AnagraficaView.vue'
import CorsiView from '../views/CorsiView.vue'
import CorsiCatalogoView from '../views/CorsiCatalogoView.vue'
import DashboardView from '../views/DashboardView.vue'
import DocentiView from '../views/DocentiView.vue'
import ImpostazioniView from '../views/ImpostazioniView.vue'
import LoginView from '../views/LoginView.vue'
import OperatoriView from '../views/OperatoriView.vue'
import ProfiloUtenteView from '../views/ProfiloUtenteView.vue'
import QuestionariView from '../views/QuestionariView.vue'
import RisultatiView from '../views/RisultatiView.vue'

const routes = [
  
  {
    path: '/anagrafica-clienti',
    name: 'anagrafica-clienti',
    component: AnagraficaView
  },
  {
    path: '/corsi',
    name: 'corsi',
    component: CorsiView
  },
  {
    path: '/catalogo',
    name: 'catalogo',
    component: CorsiCatalogoView
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView
  },
  {
    path: '/docenti',
    name: 'docenti',
    component: DocentiView
  },
  {
    path: '/impostazioni',
    name: 'impostazioni',
    component: ImpostazioniView
  },
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/operatori',
    name: 'operatori',
    component: OperatoriView
  },
  {
    path: '/profilo-utente',
    name: 'profilo-utente',
    component: ProfiloUtenteView
  },
  {
    path: '/questionari',
    name: 'questionari',
    component: QuestionariView
  },
  {
    path: '/risultati',
    name: 'risultati',
    component: RisultatiView
  },
 
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
